// File: src/pages/PropertyTypePage.jsx
import React, { useEffect, useState } from 'react';
import PropertiesComp2 from '../components/PropertiesComp2';
import SearchFilterComp2 from '../components/SearchFilterComp2';
import Footer from '../components/Footer';
import { getProjectNames, getPropertyListNew, getSearchFilterOptions } from '../services/Api';
import { useParams } from 'react-router-dom';

const UNIT_TYPE_MAP = {
  'apartment': 'Apartment',
  'penthouse': 'Penthouse',
  'office': 'Office',
  'villa': 'Villa',
  'hotel-apartment': 'Hotel Apartment',
  'full-floor': 'Full Floor',
  'duplex': 'Duplex',
  'retail': 'Retail',
  'townhouse': 'Townhouse',
};


const PropertyTypePage = () => {
    const { propertyType } = useParams(); // from route like /properties/type/:propertyType

    const [typeOptions, setTypeOptions] = useState([]);
    const [handoverYears, setHandoverYears] = useState([]);
    const [budget, setBudget] = useState("");
    const [locationSelect, setLocationSelect] = useState(null);
    const [developerOptions, setDeveloperOptions] = useState([]);
    const [developer, setDeveloper] = useState(null);
    const [projectOptions, setProjectOptions] = useState([]);
    const [project, setProject] = useState(null);
    const [inputValue, setInputValue] = useState("");
    const [keywords, setKeywords] = useState([]);
    const [type, setType] = useState(UNIT_TYPE_MAP[propertyType] || null);
    const [handover, setHandover] = useState(null);
    const [page, setPage] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    const [propertyData, setPropertyData] = useState([]);
    const [searchTrigger, setSearchTrigger] = useState(0);
    const [selectedCategory, setSelectedCategory] = useState('all');
    const [selectedLocation, setSelectedLocation] = useState('All Emirates');

    const BATCH_SIZE = 12;

    const emirateOptions = [
        { label: 'All Emirates', value: 'All Emirates' },
        { label: 'Abu Dhabi', value: 'Abu Dhabi' },
        { label: 'Dubai', value: 'Dubai' },
        { label: 'Sharjah', value: 'Sharjah' },
        { label: 'Ajman', value: 'Ajman' },
        { label: 'Umm Al Quwain', value: 'Umm Al Quwain' },
        { label: 'Ras Al Khaimah', value: 'Ras Al Khaimah' },
        { label: 'Fujairah', value: 'Fujairah' }
    ];

    useEffect(() => {
        getFilterOptions();
        getProjectList();
    }, []);

    useEffect(() => {
        fetchPropertyList(1, 'latest', true);
    }, [searchTrigger, selectedCategory, selectedLocation]);

    const getFilterOptions = async () => {
        const res = await getSearchFilterOptions();
        if (res.types) setTypeOptions(["Any Type", ...res.types]);
        if (res.handover_years) {
            const currentYear = new Date().getFullYear();
            const futureYears = res.handover_years
                .filter(year => !isNaN(year) && Number(year) >= currentYear)
                .sort((a, b) => Number(a) - Number(b));
            setHandoverYears(["Ready to move", ...futureYears]);
        }
        if (res.developers) setDeveloperOptions(["Any Developer", ...res.developers]);
    };

    const getProjectList = async () => {
        const res = await getProjectNames();
        if (res?.success) {
            const options = res.data.map(item => ({ label: item.title, id: item.id }));
            setProjectOptions(options);
        }
    };

    const handleBudgetChange = (e) => {
        const input = e.target.value.replace(/,/g, '');
        if (/^\d*$/.test(input)) {
            setBudget(Number(input).toLocaleString('en-US'));
        }
    };

    const handleChange = (e) => {
        const value = e.target.value;
        setInputValue(value);
        const keywordsArr = value.split(',').map(k => k.trim()).filter(k => k);
        setKeywords(keywordsArr);
    };

    const fetchPropertyList = async (currentPage, sortBy = 'latest', reset = false) => {
        setIsLoading(true);
        try {
            const categoryParam = selectedCategory === 'off_plan' ? 1 : selectedCategory === 'ready_to_move' ? 2 : 0;

            const response = await getPropertyListNew(
                currentPage,
                BATCH_SIZE,
                sortBy,
                categoryParam,
                type,
                budget,
                handover,
                locationSelect?.value,
                developer,
                project,
                keywords,
                selectedLocation
            );

            if (response?.results?.success) {
                const newData = response.results.data;
                setPropertyData(prev =>
                    reset || currentPage === 1
                        ? newData
                        : [...prev, ...newData.filter(p => !prev.some(item => item.id === p.id))]
                );
            }
        } catch (err) {
            console.error("Failed fetching filtered properties:", err);
        } finally {
            setIsLoading(false);
        }
    };

    const onPageChange = (newPage) => {
        setPage(newPage);
        fetchPropertyList(newPage, 'latest', false);
    };

    return (
        <div className="pt-6">
            <div className="container mx-auto pt-24 pb-15">
                <SearchFilterComp2
                    type={type}
                    setType={setType}
                    budget={budget}
                    setBudget={setBudget}
                    handover={handover}
                    setHandover={setHandover}
                    typeOptions={typeOptions}
                    handoverYears={handoverYears}
                    handleBudgetChange={handleBudgetChange}
                    emirateOptions={emirateOptions}
                    locationSelect={locationSelect}
                    setLocationSelect={setLocationSelect}
                    developer={developer}
                    setDeveloper={setDeveloper}
                    developerOptions={developerOptions}
                    project={project}
                    setProject={setProject}
                    projectOptions={projectOptions}
                    inputValue={inputValue}
                    handleChange={handleChange}
                    setPage={setPage}
                    page={page}
                    setPropertyData={setPropertyData}
                    setIsLoading={setIsLoading}
                    setSearchTrigger={setSearchTrigger}
                />
            </div>
           <PropertiesComp2
    sortBy="latest"
    heading={UNIT_TYPE_MAP[propertyType] || 'Properties'}
    paddingClasses="pt-[100px] lg:pt-[50px]"
    propertyData={propertyData}
    onPageChange={onPageChange}
    page={page}
    isLoading={isLoading}
    selectedCategory={selectedCategory}
    setSelectedCategory={setSelectedCategory}
    selectedLocation={selectedLocation}
    setSelectedLocation={setSelectedLocation}
/>

            <Footer />
        </div>
    );
};

export default PropertyTypePage;
